

export default function Statistics (props){
    return(
        <>
        <div style={{marginTop:"80px"}}>
            <h1>Statistics</h1>
        </div>
        </>
    )
}